
import InvoiceDialogue from "../../components/dialogs/invoice-dialog.vue";
import CurrencyConverter from "../common/currency-converter.vue";
export default {
  components: {
    InvoiceDialogue,
    CurrencyConverter
  },
  data() {
    return {
      dialog: false,
      loading: false
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isLastRow: {
      type: Boolean,
      default: false
    },
    isPaid: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleInvoicePopup(visibility) {
      this.dialog = visibility;
    },
    handleBtnClick() {
      if (this.isPaid) {
        this.toggleInvoicePopup(true);
      } else {
        this.loading = true;
        this.$nuxt.$emit("make-payment", this.item.id);
        this.$nuxt.$on("order-placed", () => {
          this.loading = false;
        });
        this.$nuxt.$on("payment-failed", () => {
          this.loading = false;
        });
      }
    }
  }
};
